import * as contentTypes from "../api/contentTypes"

// This is a shitty name
export const isCurrentPathActive = (slug, { ignoreQueryParams = false } = {}) => {
    if (typeof window === "undefined") {
        return false;
    }

    if( slug === null ) {
        console.log( slug );
        return false;
    }

    // Is this foolproof? I am not sure.
    const paths = window.location.pathname.split("/");
    const pathname = window.location.pathname.replace(/\/$/, "");
    const search = window.location.search;
    const slugSearch = (slug.match(/\?.*$/) || [])[0] || "";
    return (paths.includes(slug.split("?")[0]) || slug === pathname) &&
            (ignoreQueryParams || slugSearch === search);
};

// Sorry for this JS Voodoo but it works like this:
// If there is is SOME navigation group in this submenu that has SOME page that is currently active, return true,
// else false
// NAVIGATION_ITEM_EXTERNAL_LINK is not a page. It only has a title and an URL. So we should not check if it is active
export const isSubmenuActive = submenu =>
    submenu.navigationGroups &&
    submenu.navigationGroups
    .some(navGroup => navGroup.pages && navGroup.pages
    .some(page => page && page.contentType !== contentTypes.NAVIGATION_ITEM_EXTERNAL_LINK && isCurrentPathActive(page.slug)
    ));

